import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  ENUM_getInstance25239ht7oag6o as ENUM_getInstance,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  MAP_getInstance3e78m6vf98i66 as MAP_getInstance,
  LIST_getInstance2vniy0f7mmb29 as LIST_getInstance,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  CONTEXTUAL_getInstance20l1ap7hne5we as CONTEXTUAL_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { InvalidKeyKindException3b5w96w0jjxof as InvalidKeyKindException } from './JsonExceptions.mjs';
import { getContextualDescriptor2n1gf3b895yb8 as getContextualDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/ContextAware.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  LexerMode_OBJ_instance = new (LexerMode())('OBJ', 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  LexerMode_LIST_instance = new (LexerMode())('LIST', 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
  LexerMode_MAP_instance = new (LexerMode())('MAP', 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  LexerMode_POLY_OBJ_instance = new (LexerMode())('POLY_OBJ', 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
}
var LexerMode_OBJ_instance;
var LexerMode_LIST_instance;
var LexerMode_MAP_instance;
var LexerMode_POLY_OBJ_instance;
function values() {
  static_init();
  return [LexerMode_OBJ_getInstance(), LexerMode_LIST_getInstance(), LexerMode_MAP_getInstance(), LexerMode_POLY_OBJ_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var $ENTRIES;
var LexerModeClass;
function LexerMode() {
  if (LexerModeClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, begin, end) {
        super(name, ordinal);
        this.f2w_1 = begin;
        this.g2w_1 = end;
      }
    }
    initMetadataForClass($, 'LexerMode');
    LexerModeClass = $;
  }
  return LexerModeClass;
}
function modeFor(_this__u8e3s4, desc) {
  var tmp0_subject = desc.x1p();
  var tmp;
  if (tmp0_subject instanceof PolymorphicKind()) {
    tmp = LexerMode_POLY_OBJ_getInstance();
  } else {
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp = LexerMode_LIST_getInstance();
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var keyDescriptor = carrierDescriptor(desc.e1q(0), _this__u8e3s4.h1s());
        var keyKind = keyDescriptor.x1p();
        var tmp_0;
        var tmp_1;
        if (keyKind instanceof PrimitiveKind()) {
          tmp_1 = true;
        } else {
          tmp_1 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_1) {
          tmp_0 = LexerMode_MAP_getInstance();
        } else {
          if (_this__u8e3s4.i2o_1.z2p_1) {
            tmp_0 = LexerMode_LIST_getInstance();
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_0;
      } else {
        tmp = LexerMode_OBJ_getInstance();
      }
    }
  }
  return tmp;
}
function carrierDescriptor(_this__u8e3s4, module_0) {
  var tmp;
  if (equals(_this__u8e3s4.x1p(), CONTEXTUAL_getInstance())) {
    var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
    tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
  } else if (_this__u8e3s4.y1p()) {
    tmp = carrierDescriptor(_this__u8e3s4.e1q(0), module_0);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function LexerMode_OBJ_getInstance() {
  static_init();
  return LexerMode_OBJ_instance;
}
function LexerMode_LIST_getInstance() {
  static_init();
  return LexerMode_LIST_instance;
}
function LexerMode_MAP_getInstance() {
  static_init();
  return LexerMode_MAP_instance;
}
function LexerMode_POLY_OBJ_getInstance() {
  static_init();
  return LexerMode_POLY_OBJ_instance;
}
//region block: exports
export {
  LexerMode_MAP_getInstance as LexerMode_MAP_getInstance2xhiu8e07rxc7,
  LexerMode_OBJ_getInstance as LexerMode_OBJ_getInstanced06mtz6hd5jq,
  get_entries as get_entries3sj9jz7zp9ijy,
  carrierDescriptor as carrierDescriptor9eih94weel9f,
  modeFor as modeFort67zb8ch2jog,
};
//endregion

//# sourceMappingURL=LexerMode.mjs.map
